import { X } from 'lucide-react';

const Modal = ({ open, title, children, footer, onClose, size = 'md' }) => {
  if (!open) return null;

  const width = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    full: 'max-w-7xl'
  }[size];

  const bodyHeight = size === 'full' ? 'max-h-[76vh]' : 'max-h-[65vh]';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/50 p-4">
      <div className={`max-h-[90vh] w-full ${width} overflow-hidden rounded-lg bg-white shadow-xl`}>
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
          <h2 className="text-lg font-semibold text-gray-950">{title}</h2>
          <button onClick={onClose} className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-800">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className={`${bodyHeight} overflow-y-auto px-5 py-4`}>{children}</div>
        {footer && <div className="border-t border-gray-200 bg-gray-50 px-5 py-4">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
